import { I18N_FRONTEND_NAMESPACES } from 'tradera/lang/constants.mjs';

const usedKeyPageTypes = new Map();

const createNamespaces = () =>
    new Map(
        I18N_FRONTEND_NAMESPACES.map((namespace) => [namespace, new Set()])
    );

const getOrCreatePageTypeNamespaces = (pageType) => {
    if (!usedKeyPageTypes.has(pageType)) {
        usedKeyPageTypes.set(pageType, createNamespaces());
    }
    return usedKeyPageTypes.get(pageType);
};

export const addKey = (pageType, namespace, key) => {
    const usedKeys = getOrCreatePageTypeNamespaces(pageType).get(namespace);
    if (!usedKeys.has(key)) {
        usedKeys.add(key);
    }
};

export const getUsedKeys = (pageType) =>
    getOrCreatePageTypeNamespaces(pageType);
